export default __webpack_public_path__ + "static/media/cheese_1.1be883ed.png";